<template>
    <div v-if="templateModel != null">
        <div class="img_box"
            :style="{ backgroundImage: 'url(' + templateModel.bottomPictureUrl + ')', 'background-size': '100% 60%' }">
        </div>
        <div class="img_box" style="margin-top: 22.8%;"
            :style="{ backgroundImage: 'url(' + templateModel.topPictureUrl + ')', 'background-size': '100% 100%' }">
        </div>
        <div style="padding: 8% 0% 0% 8%; width: 25%; float: left;">
            <h2>{{ templateModel.title }}</h2>
            <h1 style="color: gray;">直播列表</h1>
        </div>
        <div style="position: absolute; margin-top: 13%; margin-left: 22%;" v-if="templateModel.detaillist != null">
            <span style="font-size: 28px; font-weight: bold; color: red;">{{ selectindex }}</span> <span
                style="vertical-align: super;font-size: 24px; font-weight: bold; color: grey;">
                <span>/</span> {{ templateModel.detaillist.length }}</span>
        </div>
        <div class="divlist" style="width: 75%;">
            <swiper :options="swiperOption2" ref="mySwiper">
                <swiper-slide v-for="(item, index) in templateModel.detaillist" :key="index" style="cursor: pointer;">
                    <div @click.stop="liveclk(item, index)">
                        <img src="../../assets/img/ceshi.jpg">
                        <div class="swiperdiv"
                            :class="(selectindex - 1) == index ? 'activitcolor_hor' : 'activitcolor'">
                            <img :src="item.logoUrl" />
                            <div class="livetitle">
                                {{ item.liveName }}
                            </div>
                            <div class="livetime" :style="selectindex - 1 == index ? 'color:#ffff' : 'color:gray'">{{
                                item.subtitle
                            }}</div>
                            <div class="fenge"></div>
                            <div class="activit">
                                <span style="float: left; position: absolute; width: 150px; left: 30px; top: -5px">{{
                                    item.buttonText
                                }}</span>
                                <span class="el-icon-right"></span>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
        <div class="swiperbtn">
            <div class="prevbutton2 el-icon-arrow-left circle1_circle"
                style=" color: #05BBC9; line-height: 27px;  margin-left: 50px; font-weight: bold; cursor: pointer;">
            </div>
            <div class="nextbutton2 el-icon-arrow-right circle1_circle"
                style=" color: #05BBC9; line-height: 27px;  margin-left: 50px; font-weight: bold;  cursor: pointer;">
            </div>
        </div>
    </div>
</template>
<script>
let vm;
export default {
    data() {
        return {
            Id: 0,//直播列表id
            templateModel: {},
            type: 0,  //1目睹2获得场景
            mtgId: 0,
            selectindex: 1,
            realIndex: 0,
            swiperOption2: {
                slidesPerView: 3,
                slidesPerColumnFill: 'column',
                spaceBetween: 60,
                // mousewheel: true,
                freeMode: true,
                parallax: true,
                // 如果需要前进后退按钮
                navigation: {
                    nextEl: '.nextbutton2',
                    prevEl: '.prevbutton2',
                    disabledClass: 'my-button-disabled',
                    clickable: true,
                },
                on: {
                    slideChange: function () {
                        //自定义事件
                        // console.log(this.activeIndex)
                        vm.aaa(this.activeIndex)
                    },
                    sliderMove: function () {
                        console.log(12)
                    }
                }
            }
        }
    },
    created() {
        vm = this;
        if (this.publicunit.isMobile()) {
            this.$router.push({
                path: '/channelListMobile',
                query: {
                    Id: this.$route.query.Id,
                    type: this.$route.query.type,
                    mid: this.$route.query.mid
                }
            });
        } else {
            if (this.$route.query.mid != '' && this.$route.query.mid != null) {
                this.mtgId = this.$route.query.mid;
            }
            let _this = this
            _this.Id = this.$route.query.Id
            //1目睹2获得场景
            _this.type = this.$route.query.type
            this.GetLiveTemplateList();
        }
    },
    mounted() {

    },
    methods: {
        aaa(activeIndex) {
            this.selectindex = activeIndex + 1
        },
        liveclk(item, index) {
            this.selectindex = index + 1;
            // console.log(item)
            const { href } = this.$router.resolve({
                path: '/muduLive?',
                query: {
                    id: item.liveID,
                    mid: this.mtgId
                }
            });
            window.open(href, '_blank');
        },
        //获取直播模板列表
        GetLiveTemplateList() {
            let _this = this;
            _this.httphelper.post('/api/LiveApi/GetLiveTemplateList', {
                Id: parseInt(this.Id),
            }).then(res => {
                if (res.data.code == 200) {
                    let data = res.data.data;
                    _this.templateModel = data;
                    document.title = res.data.data.title || '全科医学网'
                }
            });
        },
    },
}
</script>
<style lang="scss" scoped>
.my-button-disabled {
    display: none;

}

.circle1_circle {
    text-align: center;
    display: inline-block;
    width: 30px;
    height: 30px;
    background: #FFFFFF;
    border: 2px solid #05BBC9;
    box-sizing: border-box;
    border-radius: 27px;
    vertical-align: middle;
}


.divlist {
    margin: 16% 0% 0% 22%;
    float: left;
    position: absolute;
}

.activitcolor {
    .activitcolor {
        background-image: linear-gradient(to left, #fff, #fff);
        color: #0000;
    }
}

.activitcolor_hor {
    background-image: linear-gradient(to left, rgba(255, 28, 0, 1), red);
    color: #ffff;
}

.swiperdiv {
    width: 390px;
    background-color: #ffff;
    margin-top: -4px;
    height: 170px;
    box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19) !important;
    margin-bottom: 25px;

    img {
        border-radius: 50%;
        margin: 30px;
        float: left;
        position: absolute;
        width: 50px;
    }
}

.livetime {
    color: gray;
    position: absolute;
    margin-top: 22%;
    left: 100px;
    font-size: 12px;
}

.activit {
    position: absolute;
    margin-top: 32%;

    .el-icon-right {
        float: right;
        position: absolute;
        left: 340px
    }
}

.fenge {
    width: 80%;
    border-top: 1px solid #ccc;
    margin-left: 5%;
    margin-right: 5%;
    margin-top: 27%;
    position: absolute;
}

.swiperbtn {
    position: absolute;
    margin: 35% 0% 0% 10%;
}

@media only screen and (max-width: 1900px) {
    .swiperdiv {
        width: 390 * 0.87 (+px);
    }

    .fenge {
        width: 90%;
        margin-top: 37%;
    }

    .activit {
        margin-top: 42%;

        .el-icon-right {
            left: 290px
        }

    }

    .livetime {
        margin-top: 30%;
    }

    .swiperbtn {
        margin: 38% 0% 0% 10%;
    }
}

.livetitle {
    margin-top: 30px;
    margin-left: 100px;
    width: 60%;
    font-size: 14px;
    font-weight: 600;
    position: absolute;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
}

.img_box {
    width: 100%;
    height: 80%;
    /* background-image: url(../assets/img/bg01.png); */
    background-size: 100% 100%;
    /* 使图片平铺满整个浏览器（从宽和高的最大需求方面来满足，会使某些部分无法显示在区域中） */
    position: absolute;
    /* 不可缺少 */
    overflow: hidden;
    overflow: auto;
    z-index: -1;
    background-repeat: no-repeat;
}

/* 注释部分要不要都一样 */
</style>